import {useState, useEffect, useRef} from 'react'
import axios from 'axios'
import CurrencyFormat from 'react-currency-format'
import {DataTable} from 'primereact/datatable'
import { DataView } from 'primereact/dataview';
import { Card } from 'primereact/card';
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import {FilterMatchMode, FilterOperator} from 'primereact/api'
import {Column} from 'primereact/column'
import {WithdrawDetail} from './WithdrawDetail'
import { useLocation } from 'react-router-dom';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}


const WithdrawList = () => {
    const apiToken = getLocalData().api_token

    const location = useLocation()
    const search_state = location.state

    const [WithdrawDatas, setWithdrawDatas] = useState([])

    const [showWithdrawDetailModal, setShowWithdrawDetailModal] = useState(false)
    const [withdrawId, setWithdrawId] = useState()

    const API_URL = process.env.REACT_APP_API_URL
    const GET_WITHDRAW_URL = `${API_URL}/user/withdraws`

    const [loading, setLoading] = useState(false)
    const [loadParams,setLoadParams] = useState({first:0,rows:10})
    const [totalRecords,setTotalRecords] = useState(0)
    const dataFetchCountRef = useRef(0);
    const lastRange = useRef({first:0,rows:10});

    const [globalFilterValue, setGlobalFilterValue] = useState('')
      const [filters, setFilters] = useState({
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      })
      const [daysFilter, setDaysFilter] = useState('15')
      
      const isMobileDevice = MobileUse();
      const data = WithdrawDatas

    const getWithdraws = async (daysFilterData,offsetValue,limitValue,globalFilterValue) => {
    setLoading(true)
    const config = {
      headers: {Authorization: `Bearer ${apiToken}`},
      params: {
          days_filter: daysFilterData,
          offset:offsetValue,
          limit:limitValue,
          search:globalFilterValue
        },
    }
    await axios
      .get(GET_WITHDRAW_URL, config)
      .then((response) => {
        setWithdrawDatas(prev => [...prev, ...response.data.data])
        setTotalRecords(response.data.total)
        dataFetchCountRef.current += 10
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }

  const currentRequest = useRef(false)

  useEffect(() => {
    if(currentRequest.current == false){
      getWithdraws(daysFilter,loadParams.first,loadParams.rows,globalFilterValue)
      currentRequest.current = true
    }
    }, [loadParams])

    const OpenViewDetailModal = (withdraw_code) => {
    setWithdrawId(withdraw_code)
    setShowWithdrawDetailModal(true)
  }

  const handleDaysChange = (e) => {
    const selectedDays = e.target.value
    setDaysFilter(selectedDays)
    setWithdrawDatas([])
    resetParams()
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    setGlobalFilterValue(value)
    setWithdrawDatas([])
    resetParams()
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const scrollTop = window.scrollY; // current scroll position
    const windowHeight = window.innerHeight; // viewport height
    const fullHeight = document.documentElement.scrollHeight; // total page height

    if (scrollTop + windowHeight >= fullHeight - 5) {
      if(totalRecords == 0 || loadParams.first < totalRecords){
        loadMoreData()
      }
    }
  }

  const loadMoreData = ()=>{
    console.log('executed 1');
    currentRequest.current = false
    const prevFirst = dataFetchCountRef.current;
    const newLoadParams = {first:prevFirst, rows:10};
    
    if(newLoadParams.first > lastRange.current.first){
      setLoadParams(newLoadParams);
      lastRange.current = newLoadParams;
      console.log('executed 2');
    }
  }

  useEffect(() => {
      if (search_state?.id && search_state?.query) {
        const value = search_state?.query
        setGlobalFilterValue(value)
        setDaysFilter('ALL')
        setWithdrawDatas([]);
        resetParams()
      }
    }, [search_state])

  const resetParams = ()=>{
    setLoadParams({first:0,rows:10});
    lastRange.current = {first:0,rows:10};
    dataFetchCountRef.current = 0
    currentRequest.current = false
  }
  

  const renderHeader = () => {
    return (
      <div className='row'>
        <div className='col-lg-6 col-md-12'>
          <input
            value={globalFilterValue}
            className='form-control form-control-sm filter-search-table'
            onChange={onGlobalFilterChange}
            placeholder='Search'
          />
        </div>
        <div className='col-lg-6 col-md-12 mt-3 d-lg-flex justify-content-end'>
          <select
            id='daysFilter'
            className='form-select form-select-sm days-filter-select'
            value={daysFilter}
            onChange={handleDaysChange}
          >
            <option value='15'>15 Days</option>
            <option value='30'>30 Days</option>
            <option value='90'>3 Months</option>
            <option value='365'>365 Days</option>
            <option value='All'>All Data</option>
          </select>
        </div>
      </div>
    )
  }

  const paymentBody = (val)=>{
    return(
        <CurrencyFormat
        decimalScale={2}
        value={parseFloat(val.payment).toFixed(2)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        />
    )
  }
  const amountBody = (val)=>{
    return(
        <CurrencyFormat
        decimalScale={2}
        value={parseFloat(val.amount).toFixed(2)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        />
    )
  }
  const statusBody = (val)=>{
    return(
        <div>
            {val.status == 0 && (
            <span className='badge badge-light-success fs-8 fw-bold success_active'>
                Approved
            </span>
            )}
            {val.status == 1 && (
            <span className='badge badge-light-warning fs-8 fw-bold warning_active'>
                Pending
            </span>
            )}
            {val.status == 2 && (
            <span className='badge badge-light-danger fs-8 fw-bold danger_active'>
                Rejected
            </span>
            )}
            {val.status == 3 && (
            <span className='badge badge-light-info fs-8 fw-bold info_active'>
                Partial
            </span>
            )}
        </div>
        
    )
  }
  const actionBody = (val)=>{
    return(
        <a href='#' onClick={() => OpenViewDetailModal(val.withdraw_code)}>
        View Detail
        </a>
    )
  }

  const dataViewList = (items)=>{
      return(
        <div className="data-items">
          {
            items.map((item, idx) => (
              <DataViewItem item={item} idx={idx}/>
            ))
          }
        </div>
      )
    }
  
    const DataViewItem = ({item,idx}) =>{
      return(
        <Card key={idx} className="mb-3" style={{borderBottom:'3px solid black'}}>
            {/* <div className="p-d-flex p-ai-center mb-2"></div> */}
            <div className="row d-flex align-items-center pb-0">
              <div className="col-9">
                <h4 className="">{item.withdraw_no}</h4>
              </div>
              <div className="col-3">
                <div>{statusBody(item)}</div>
              </div>
            </div>
            <div className="row mt-3 pb-0">
              <div className="col-3">
                <h5 className='text-success'>{paymentBody(item)}</h5>
              </div>
              <div className="col-6">
                <span><b>Paid On : </b>{item.date}</span>
              </div>
              <div className="col-3">
                <div className="">{actionBody(item)}</div>
              </div>
            </div>
            
            
          </Card>
      )
    }


  const header = renderHeader()

  return (
    <>
    <WithdrawDetail
        show={showWithdrawDetailModal}
        handleClose={() => setShowWithdrawDetailModal(false)}
        withdrawId={withdrawId}
      />
      <div className="list">
        {!isMobileDevice ? (
      
      <div>
        <DataTable
        value={WithdrawDatas}
        tableStyle={{minWidth: '50rem',margin:'auto'}}
        size='large'
        globalFilterFields={['withdraw_no']}
        dataKey='id'
        filters={filters}
        header={header}
        stripedRows
      >
        <Column field='withdraw_no' header='Withdraw' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column field='date' header='Paid On' style={{width: '10%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column body={paymentBody} header='Payment' style={{width: '15%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column body={amountBody} header='Amount' style={{width: '15%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column body={statusBody} header='Status' style={{width: '15%',paddingTop: 10,paddingBottom: 10}}></Column>
        <Column body={actionBody} header='Action' style={{width: '15%',paddingTop: 10,paddingBottom: 10}}></Column>
      </DataTable>
      </div>
      ) : (
        <div className="card">
          <div className="card-header px-0">{header}</div>
          <div className="card-body px-0 py-1">
            <div className="mobile-card-container">
          {data.length === 0 ? (
            <p className="p-text-center ms-5">You have no withdraws.</p>
          ) : (
            <DataView 
              value={WithdrawDatas}
              listTemplate={dataViewList}
            />
          )}
        </div>
          </div>
        </div>
      )}
      </div>
      <div className="container text-center">
        {loading ? 
          <button type='button' className='btn btn-light w-lg-50 w-100'>Loading...</button>
        :
          <button type='button' className='btn btn-light w-lg-50 w-100' onClick={loadMoreData}>{(loadParams.first < totalRecords) ? 'Load More' : 'No More Data for this Filter...'}</button>
        }
        
      </div>
    </>
  )
}

export default WithdrawList